import { Check } from '@saleshandy/icons';
import React from 'react';
import { useSelector } from 'react-redux';
import purchaseDialerImg from '../../../../../../assets/images/purchase-dialer.png';
import {
  accessibleOnClick,
  contactAdmin,
  redirectWithoutRefresh,
} from '../../../../../../shared/utils';
import { Permissions } from '../../../../../../shared/utils/access-control/enums/permissions';
import hasPermission from '../../../../../../shared/utils/access-control/has-permission';
import { RootState } from '../../../../../../store/root-reducer';
import './purchase-dialer-card.scss';

const FEATURES = [
  'Make and Receive Calls',
  'Execute Calling Tasks',
  'Record and Transcribe Conversations',
  'Get AI Call Summaries',
  'Create Voicemail Templates',
];

const PurchaseDialerCard: React.FC = () => {
  const { firstName, lastName, adminDetails } = useSelector(
    (state: RootState) => state.home,
  );

  const canPurchase = hasPermission(Permissions.PHONE_NUMBER_PURCHASE_READ);

  const handleContactOwner = () => {
    const ownerName = [adminDetails?.firstName, adminDetails?.lastName]
      .filter(Boolean)
      .join(' ');
    const requesterName = [firstName, lastName].filter(Boolean).join(' ');

    const subject = 'Request to Buy a Dialer Plan';
    const body = `Hi ${ownerName},\n\n${requesterName} has requested access to the Saleshandy Dialer, but they currently don't have a dialer plan.\n\nWithout a dialer plan, they are unable to make or receive calls through Saleshandy.\n\nAs the account owner, you can buy a dialer plan from the Billing & Subscription section in your workspace.\n\nIf you have any questions, feel free to reach out to our support team.\n\nThanks,\nSaleshandy Team`;

    contactAdmin(subject, body);
  };

  const handleButtonClick = () => {
    if (canPurchase) {
      redirectWithoutRefresh('/billing/upgrade-plan/dialer');
    } else {
      handleContactOwner();
    }
  };

  return (
    <div className="bs-purchase-dialer-card">
      <div className="bs-purchase-dialer-card__content">
        <h3 className="bs-purchase-dialer-card__heading">
          Add Calling to Your Outreach With Saleshandy Dialer
        </h3>
        <ul className="bs-purchase-dialer-card__features">
          {FEATURES.map((feature) => (
            <li key={feature} className="bs-purchase-dialer-card__feature-item">
              <Check className="bs-purchase-dialer-card__feature-icon" />
              <span className="bs-purchase-dialer-card__feature-text">
                {feature}
              </span>
            </li>
          ))}
        </ul>
        <button
          type="button"
          className="bs-purchase-dialer-card__cta-button"
          {...accessibleOnClick(handleButtonClick)}
        >
          {canPurchase ? 'Get Dialer Access' : 'Contact Admin'}
        </button>
      </div>
      <div className="bs-purchase-dialer-card__image-wrapper">
        <img
          src={purchaseDialerImg}
          alt="Saleshandy Dialer"
          className="bs-purchase-dialer-card__image"
        />
      </div>
    </div>
  );
};

export default PurchaseDialerCard;
